<mat-selection-list multiple="false">
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/fleet/dashboard']">
        Dashboard
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/book']">
        Book a Service
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/fleet/quotes']">
        Quotes
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['fleet/appointments']">
        Appointments
    </mat-list-option>

    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['fleet/vehicles']">
        Vehicles
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/fleet/employees']">
        Employees
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/fleet/locations']">
        Locations
    </mat-list-option>
    <mat-list-option *ngIf="selectedRole?.roleACL.manageOrganization
                            && selectedRole?.orgContext.regionId === 0"
                     (click)="toggleNav.emit()" [routerLink]="['/fleet/regions']">
        Regions
    </mat-list-option>
    <mat-list-option *ngIf="selectedRole?.roleACL.manageOrganization
                            && selectedRole?.orgContext.hubId === 0"
                     (click)="toggleNav.emit()" [routerLink]="['/fleet/hubs']">
        Hubs
    </mat-list-option>

    <mat-list-option
        (click)="toggleNav.emit()"
        *ngIf="isMaster || this.selectedRole?.roleACL?.updateApprovalCriteria"
        [routerLink]="['/account/approvallimits']">
        Approval Limits
    </mat-list-option>
    <mat-list-option
        (click)="toggleNav.emit()"
        [routerLink]="['account/invoices']"
        *ngIf="isMaster || this.selectedRole?.roleACL?.manageOrganization">
        Invoices
    </mat-list-option>

    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/account']">
        Profile
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/notifications']">
        Notifications
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()">
        <a style="color: white;" href="/service/towing-and-roadside-assistance">Roadside Assistance</a>
    </mat-list-option>
    <mat-list-option (click)="toggleNav.emit()" [routerLink]="['/login']">
        Logout
    </mat-list-option>
</mat-selection-list>
